import { isAuthenticatedUsecaseFactory } from '../../domain/usecase/is-authenticated.usecase';
import { loginUsecaseFactory } from '../../domain/usecase/login.usecase';
import { userLoggedUsecaseFactory } from '../../domain/usecase/user-logged.usecase';
import { logoutUsecaseFactory } from '../../domain/usecase/logout.usecase';
import { getAccessTokenUsecaseFactory } from '../../domain/usecase/get-access-token.usecase';
import { refreshAccessTokenUsecaseFactory } from '../../domain/usecase/refresh-access-token.usecase';
import { getScopesUsecaseFactory } from '../../domain/usecase/get-scopes.usecase';
import { checkUserAuthSessionUsecaseFactory } from '../../domain/usecase/check-user-auth-session.usecase';
import { signinUsecaseFactory } from '../../domain/usecase/signin.usecase';
export function authService(config, authRepository) {
    return {
        isAuthenticated: isAuthenticatedUsecaseFactory({ authRepository }),
        login: loginUsecaseFactory({ authRepository }),
        onUserLogged: userLoggedUsecaseFactory({ authRepository }),
        logout: logoutUsecaseFactory({ authRepository }),
        getAccessToken: getAccessTokenUsecaseFactory({ authRepository }),
        refreshAccessToken: refreshAccessTokenUsecaseFactory({ authRepository }),
        getScopes: getScopesUsecaseFactory({ authRepository }),
        checkUserAuthSession: checkUserAuthSessionUsecaseFactory({
            authRepository,
            requiredScopes: config.requiredScopes,
            signupScopes: config.signupScopes,
        }),
        signin: signinUsecaseFactory({ authRepository }),
    };
}
//# sourceMappingURL=index.js.map